import { Injectable, signal, computed,  } from '@angular/core';
import { CouponFormat } from './models/couponFormat.model';
import { Plan } from './models/plan.model';
import { DirectApiService } from './directApi.service';
import { lastValueFrom } from 'rxjs';

import { PlanService } from './plan-data.service';


@Injectable({
    providedIn: 'root'
})

/** The words promo and coupon are used interchangeably */
export class PromoService {

  //-------v COUPONS
    private _couponSignal = signal<CouponFormat >({} as CouponFormat);
    public couponSignal = computed(() => this._couponSignal());
    updateCouponSignal(value: CouponFormat) {
      this._couponSignal.set(value);
    }
    get couponSignalValue(): CouponFormat {
      return this._couponSignal();
    }


    private _couponErrorFlag = signal<boolean>(false);
    public couponErrorFlagSignal = computed(() => this._couponErrorFlag());

    private _couponInputValue = signal<string>("");
    public couponInputSignal = computed(() => this._couponInputValue());
    updateCouponInputSignal(code: string) {
      if(code != ""){
        if(this._couponInputValue() !== code){
          this._couponInputValue.set(code.toUpperCase());
        }
      }
    }
    get couponInputSignalValue(): string {
      return this._couponInputValue();
    }
    async validateCouponInputSignal(currentPlan: Plan){
      if(this.couponInputSignal() != "" && currentPlan != undefined){
      }
      else if(this.couponInputSignalValue === ""){
        this.updateCouponSignal({} as CouponFormat);
      }

      try{
        let validatedCoupon = await this.checkCouponCode(currentPlan.urlExtension);

        if( this.isCouponFormat(validatedCoupon) ) {
          this.updateCouponSignal(validatedCoupon);
          this._couponErrorFlag.set(false);

        } else if(this.couponInputSignalValue != null && this.couponInputSignalValue.length > 0){
          this._couponErrorFlag.set(true);
        }
      }catch (e){
        console.error("Error checking coupon code: ", e);
        this._couponErrorFlag.set(true);
      }
    }
  //-------^ COUPONS

  constructor(
    public directApiService: DirectApiService,
    public planDataService: PlanService,
  ) {

  }


  get urlPlanExtension(): string | null {
    return this.planDataService.planSelectionFromUrl();
  }

  async checkCouponCode( planId:string) {
     
    let couponCode = this.couponInputSignalValue.toUpperCase();
    let preFilteredCoupon : CouponFormat = {} as CouponFormat;

    console.log("Checking coupon code: ", couponCode, " for plan: ", planId);

    if(couponCode.length == 0) { 
      return {} as CouponFormat; 
    }

    try {
      const data = await lastValueFrom(this.directApiService.FetchCouponWithCode(couponCode));
      // console.log("Fetched coupon data: ", data);
      if (this.isCouponFormat(data)) {
        preFilteredCoupon = data as CouponFormat;
        return this.activePlanFiltering(preFilteredCoupon, planId);
      }
      return {} as CouponFormat;
    } catch (error) {
      console.error("Error fetching coupon data: ", error);
      return {} as CouponFormat;
    }
  }

  isCouponFormat( obj: any): obj is CouponFormat{
    return (
      typeof obj === 'object' &&
      typeof obj.code === 'string' &&
      typeof obj.name === 'string' &&
      //typeof obj.active === 'boolean' &&
      typeof obj.message === 'string' &&
      typeof obj.dollarDiscount === 'number' &&
      typeof obj.percentDiscount === 'number'
    )
  };

  activePlanFiltering(preFilteredCoupon: CouponFormat, planId: string): CouponFormat {
    let activePlans = preFilteredCoupon.activePlans ?? [];

    if(activePlans.length != 0){

      if(activePlans.includes(planId)) {
        return preFilteredCoupon as CouponFormat;
      }
      else {
        return {} as CouponFormat;
      }

    }else{
      return preFilteredCoupon as CouponFormat;
    }
  }
}